const config = {
  REACT_APP_HOST_API_AUTENTICACAO: process.env.REACT_APP_HOST_API_AUTENTICACAO,
  // Tela importadores: usar sempre api-importacao-xml (IMPORTACAO_XML). Nunca api-financeiro.
  REACT_APP_HOST_API_IMPORTACAO_XML: process.env.REACT_APP_HOST_API_IMPORTACAO_XML,
  REACT_APP_HOST_API_IMPORTACOES: process.env.REACT_APP_HOST_API_IMPORTACOES,
  REACT_APP_HOST_API_PLANEJAMENTO_TRIBUTARIO:
    process.env.REACT_APP_HOST_API_PLANEJAMENTO_TRIBUTARIO,
  REACT_APP_HOST_API_INSS: process.env.REACT_APP_HOST_API_INSS,
  REACT_APP_HOST_WEBSOCKET: process.env.REACT_APP_HOST_WEBSOCKET,
  REACT_APP_SECRET_KEY: process.env.REACT_APP_SECRET_KEY,
  REACT_APP_HOST_API_RELATORIOS: process.env.REACT_APP_HOST_API_RELATORIOS,
  /** Base URL da api-relatorios-entrega (Excel assíncrono, schema relatorios). */
  REACT_APP_HOST_API_RELATORIOS_ENTREGA:
    process.env.REACT_APP_HOST_API_RELATORIOS_ENTREGA,
  REACT_APP_HOST_API_FINANCEIRO: process.env.REACT_APP_HOST_API_FINANCEIRO,
  REACT_APP_HOST_API_CONTRATOS: process.env.REACT_APP_HOST_API_CONTRATOS,
  REACT_APP_HOST_API_RPA: process.env.REACT_APP_HOST_API_RPA,
  REACT_APP_HOST_API_ESOCIAL: process.env.REACT_APP_HOST_API_ESOCIAL,

  REACT_APP_HOST_API_EMPRESAS: process.env.REACT_APP_HOST_API_EMPRESAS,  
  REACT_APP_HOST_API_IMPORTACAO_XML: process.env.REACT_APP_HOST_API_IMPORTACAO_XML,
  
 REACT_APP_HOST_API_PISCOFINS: process.env.REACT_APP_HOST_API_PISCOFINS,
 REACT_APP_HOST_API_CONTA_CORRENTE: process.env.REACT_APP_HOST_API_CONTA_CORRENTE,

  REACT_APP_HOST_API_EMPRESAS: process.env.REACT_APP_HOST_API_EMPRESAS,

};

// Debug: api-importadores.service usa IMPORTACAO_XML || IMPORTACOES (nessa ordem)
if (process.env.REACT_APP_HOST_API_IMPORTACAO_XML) {
 
} else if (process.env.REACT_APP_HOST_API_IMPORTACOES) {
  
} else {
  console.warn('[config.js] Nem REACT_APP_HOST_API_IMPORTACAO_XML nem REACT_APP_HOST_API_IMPORTACOES definidas');
}

export default config;
